import { all } from 'redux-saga/effects'
import settings from './settings/sagas'
import sent from './sent/sagas'
import user from './user/sagas'
import menu from './menu/sagas'
import header from "./header/sagas";
import users from './users/sagas';
import workspaces from './workspace/sagas';
import workspaceusers from "./workspace_users/sagas";
import contactType from "./contact_type/sagas"
import addressType from "./address_types/sagas"
import client from "./client/sagas"
import contacts from "./contacts/sagas"
import addresses from "./addresses/sagas"
import attributes from "./attributes/sagas";
import attributesType from "./attributes_types/sagas"
import countries from "./countries/sagas"
import notes from "./notes/sagas"
import consentTypes from "./consent_types/sagas"
import consent from "./consents/sagas"
import employees from "./employees/sagas"
import employeeDocumentTypes from "./employee-document-type/sagas"
import employeeDocuments from "./employee_documents/sagas"
import documents from "./documents/sagas"
import vehicles from "./vehicles/sagas"
import devices from "./devices/sagas"
import customers from "./customers/sagas"
import drivers from "./drivers/sagas"
import customerConfiguration from "./customer_configuration/sagas"
import statistics from "./statistics/sagas"
import vehicleConfiguration from "./vehicle_configuration/sagas"
import exceedingLimits from "./customer_exceeding_limits/sagas"
import customerWorkspace from "./customer_workspace/sagas"
import ecoDriving from "./ecodriving/sagas"
import invoices from "./invoices/sagas"
import tariffs from "./tariffs/sagas"
import payments from "./payment/sagas"
export default function* rootSaga() {
    yield all([
        settings(),
        user(),
        menu(),
        header(),
        users(),
        workspaces(),
        workspaceusers(),
        contactType(),
        addressType(),
        consentTypes(),
        attributesType(),
        client(),
        contacts(),
        addresses(),
        attributes(),
        countries(),
        notes(),
        consent(),
        employees(),
        employeeDocumentTypes(),
        employeeDocuments(),
        documents(),
        vehicles(),
        devices(),
        customers(),
        drivers(),
        customerConfiguration(),
        statistics(),
        vehicleConfiguration(),
        exceedingLimits(),
        customerWorkspace(),
        ecoDriving(),
        invoices(),
        tariffs(),
        payments(),
        sent()
    ])
}
